<div class="flex wrapper" flex-align-items-center matChipRemove>
    <div class="chip-content-text"
         matTooltip="{{selectedTag?.tAG_NAME || selectedTag?.FULL_NAME || selectedTag?.aTTRIBUTE_NAME}}">
        {{ selectedTag?.displayName || selectedTag?.tAG_NAME || selectedTag?.FULL_NAME || selectedTag?.aTTRIBUTE_NAME }}
    </div>
    <div class="flex icon-wrapper" flex-align-items-center>
        <mat-icon (click)="removeTag(selectedTag)" *ngIf="allowDelete" svgIcon="close"></mat-icon>
    </div>
</div>
